import GenericSearchInput from './generic-search-input.vue'
import SocialNumberInput from './social-number-input.vue'
import CpfInput from './cpf-input.vue'
import PhoneInput from './phone-input.vue'
import EmailInput from './email-input.vue'
import GenericTextInput from './generic-text-input.vue'

export {
  GenericTextInput,
  GenericSearchInput,
  SocialNumberInput,
  CpfInput,
  PhoneInput,
  EmailInput,
}
